"use client"

import { useState, useEffect } from "react"
import { addProduct, updateProduct } from "../comman/Product.js"

const ProductModal = ({ isModalOpen, setIsModalOpen, productToEdit, onAddProduct, onUpdateProduct }) => {
  const [fileName, setFileName] = useState("")
  const [file, setFile] = useState(null)
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    productName: "",
    coin: "",
    sport: "",
    description: "",
  })

  useEffect(() => {
    if (productToEdit) {
      setFormData({
        productName: productToEdit.productName || "",
        coin: productToEdit.coin || "",
        sport: productToEdit.sport || "",
        description: productToEdit.description || "",
      })
      setFileName(productToEdit.productImage || "")
    } else {
      setFormData({
        productName: "",
        coin: "",
        sport: "",
        description: "",
      })
      setFileName("")
      setFile(null)
    }
  }, [productToEdit])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0]
    if (uploadedFile) {
      setFile(uploadedFile)
      setFileName(uploadedFile.name)
    }
  }

  const handleFileDelete = () => {
    setFileName("")
    setFile(null)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    const newProductData = {
      _id: productToEdit ? productToEdit._id : Date.now().toString(),
      ...formData,
      productImage: fileName,
      sport: formData.sport.toLowerCase(),
    }

    try {
      if (productToEdit) {
        const updatedProduct = await updateProduct(newProductData, file)
        onUpdateProduct(updatedProduct)
      } else {
        const newProduct = await addProduct(newProductData, file)
        onAddProduct(newProduct)
      }
      setIsModalOpen(false)
    } catch (error) {
      console.error("Error submitting product:", error)
      alert("Failed to submit the product")
    } finally {
      setLoading(false)
    }
  }

  if (!isModalOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-semibold text-gray-800">{productToEdit ? "Edit Product" : "Add Product"}</h2>
            <button onClick={() => setIsModalOpen(false)} className="text-gray-400 hover:text-gray-600">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="productName" className="block text-sm font-medium text-gray-700 mb-1">
                Product Name
              </label>
              <input
                type="text"
                id="productName"
                name="productName"
                value={formData.productName}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                required
              />
            </div>
            <div>
              <label htmlFor="coin" className="block text-sm font-medium text-gray-700 mb-1">
                Coin
              </label>
              <input
                type="number"
                id="coin"
                name="coin"
                value={formData.coin}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                required
              />
            </div>
            <div>
              <label htmlFor="sport" className="block text-sm font-medium text-gray-700 mb-1">
                Category (Sport)
              </label>
              <input
                type="text"
                id="sport"
                name="sport"
                value={formData.sport}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                required
              />
            </div>
            <div>
              <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
                Description
              </label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                rows={3}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#12143F] focus:border-[#12143F]"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Product Image</label>
              <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                <div className="space-y-1 text-center">
                  <svg
                    className="mx-auto h-12 w-12 text-gray-400"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 48 48"
                    aria-hidden="true"
                  >
                    <path
                      d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <div className="flex text-sm text-gray-600">
                    <label
                      htmlFor="file-upload"
                      className="relative cursor-pointer bg-white rounded-md font-medium text-[#12143F] hover:text-[#12143F] focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-[#12143F]"
                    >
                      <span>Upload a file</span>
                      <input
                        id="file-upload"
                        name="file-upload"
                        type="file"
                        className="sr-only"
                        onChange={handleFileChange}
                      />
                    </label>
                    <p className="pl-1">or drag and drop</p>
                  </div>
                  <p className="text-xs text-gray-500">PNG, JPG, GIF up to 10MB</p>
                </div>
              </div>
              {fileName && (
                <div className="mt-2 flex items-center justify-between bg-gray-100 p-2 rounded-md">
                  <span className="text-sm truncate">{fileName}</span>
                  <button type="button" onClick={handleFileDelete} className="text-red-500 hover:text-red-700">
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      ></path>
                    </svg>
                  </button>
                </div>
              )}
            </div>
          </form>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse rounded-b-lg">
          <button
            type="submit"
            onClick={handleSubmit}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-[#12143F] text-base font-medium text-white hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#12143F] sm:ml-3 sm:w-auto sm:text-sm"
            disabled={loading}
          >
            {loading ? "Submitting..." : productToEdit ? "Update Product" : "Add Product"}
          </button>
          <button
            type="button"
            onClick={() => setIsModalOpen(false)}
            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#12143F] sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default ProductModal

